import { FC, SVGProps } from 'react';

export const ArrowBackIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 22 22' fill='none' {...props}>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M9.90849 15.246L6.08624 11.4237C5.85169 11.1892 5.85169 10.8089 6.08625 10.5743L9.90849 6.75209C10.143 6.51753 10.5233 6.51753 10.7579 6.75209C10.9924 6.98664 10.9924 7.36692 10.7579 7.60147L7.96093 10.3984L16.4033 10.3984C16.735 10.3984 17.0039 10.6673 17.0039 10.999C17.0039 11.3307 16.735 11.5996 16.4033 11.5996L7.96093 11.5996L10.7579 14.3966C10.9924 14.6311 10.9924 15.0114 10.7579 15.246C10.5233 15.4805 10.143 15.4805 9.90849 15.246Z'
			fill='currentColor'
		/>
	</svg>
);
